import {LevelThree} from "./LevelThree";
import {menuStore} from "./store";
import {mapState} from 'ui.vue3.pinia'

export const LevelTwo = {
    components: {
        LevelThree
    },
    props: {
        ar2Item: Object
    },
    emits: ['open'],
    computed: {
        ...mapState(menuStore, ['isMobile', 'parent']),
        cssClass() {
            return {
                open: this.ar2Item.isShow
            }
        },
    },
    methods: {
        open(e) {
            if (this.isMobile) {
                e.preventDefault();
            }
            this.$emit('open');
            this.ar2Item.isShow = true
        },
    },
    // language=Vue
    template: `
    <div class="header-nav-main-unit-body-section-segment" :class="cssClass">
        <a
          class="header-nav-main-unit-body-section-segment-title"
          @click="open($event)"
          :class="{highlightMenu : ar2Item.isShow}"
          :href="ar2Item['href']"
          v-html="ar2Item['text']"
        ></a>
        <div class="header-nav-main-unit-body-section-segment-body">
            <a v-if="ar2Item['show_all_position_top']" class="header-nav-main-unit-body-section-segment-all" :href="ar2Item['href']">Посмотреть все</a>
            <LevelThree v-for="(ar3Item, key) in ar2Item.children"
                :ar3Item="ar3Item">
            </LevelThree>
            <a v-if="!ar2Item['show_all_position_top']" class="header-nav-main-unit-body-section-segment-all" :href="ar2Item['href']">Посмотреть все</a>
        </div>
    </div>
   
`
}